import createClient from "openapi-fetch";
import type { components, paths } from "./schema";
import { API_BASE, authFetch } from "./session";

export type Schemas = components["schemas"];
export type Me = Schemas["Me"];
export type Workspace = Schemas["Workspace"];
export type Role = Schemas["Role"];
export type Permission = Schemas["Permission"];
export type Member = Schemas["Member"];
export type Invitation = Schemas["Invitation"];
export type Warehouse = Schemas["Warehouse"];
export type ActivityEntry = Schemas["ActivityEntry"];
export type Session = Schemas["Session"];
export type ChannelPlatform = Schemas["ChannelPlatform"];
export type ChannelPlatformName = Schemas["ChannelPlatformName"];
export type ChannelConnection = Schemas["ChannelConnection"];
export type ChannelConnectionDetail = Schemas["ChannelConnectionDetail"];
export type SKU = Schemas["SKU"];
export type OrderStatus = Schemas["OrderStatus"];
export type OrderSummary = Schemas["OrderSummary"];
export type OrderDetail = Schemas["OrderDetail"];
export type StockRow = Schemas["StockRow"];
export type StockDetail = Schemas["StockDetail"];

/** Typed client generated from backend/api/openapi.yaml. */
export const api = createClient<paths>({
  baseUrl: API_BASE,
  credentials: "include",
  fetch: authFetch,
});

/** Error thrown by `unwrap`. `code` is the server's stable error code. */
export class ApiError extends Error {
  readonly status: number;
  readonly code: string;
  readonly fields: Record<string, string>;
  readonly requestId?: string;

  constructor(status: number, code: string, message: string, fields: Record<string, string> = {}, requestId?: string) {
    super(message);
    this.status = status;
    this.code = code;
    this.fields = fields;
    this.requestId = requestId;
  }
}

type ErrorBody = { error?: { code?: string; message?: string; fields?: Record<string, string>; requestId?: string } };

/**
 * Turns an openapi-fetch result into data-or-throw, so React Query and form
 * handlers can use ordinary try/catch.
 */
export async function unwrap<T>(
  promise: Promise<{ data?: T; error?: unknown; response: Response }>,
): Promise<T> {
  let result: { data?: T; error?: unknown; response: Response };
  try {
    result = await promise;
  } catch {
    throw new ApiError(0, "network", "Network error");
  }
  const { data, error, response } = result;
  if (response.ok) return data as T;
  const body = (error ?? {}) as ErrorBody;
  throw new ApiError(
    response.status,
    body.error?.code ?? (response.status >= 500 ? "generic" : "unknown"),
    body.error?.message ?? response.statusText,
    body.error?.fields ?? {},
    body.error?.requestId ?? response.headers.get("X-Request-ID") ?? undefined,
  );
}
